if (!customElements.get('marquee-content')) {
class UKMarquee extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
    }
    calculationPaddingSection() {
      (this.heightSection = this.offsetHeight),
        (this.heightSection =
          this.heightSection < 18
            ? 18
            : 96 < this.heightSection
            ? 96
            : this.heightSection),
        this.closest(".js-running-content").style.setProperty(
          "--spacing-padding-block",
          this.heightSection + "px"
        );
    }
    init() {
      (this.distance = this.querySelector(".js-marquee-item").offsetWidth),
        (this.speed = this.dataset.speed),
        this.style.setProperty(
          "--marquee-duration",
          this.distance / this.speed + "s"
        );
    }
}
customElements.define("marquee-content", UKMarquee);
}

class slideshowSwiper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sliderWrapper = this.querySelector(".slideshow__swiper");
    if (!this.sliderWrapper) return;
    const resizeObserver = new ResizeObserver((entries) => this.init());
    resizeObserver.observe(this.sliderWrapper);
      // console.log("testdd",this.sliderWrapper.dataset)
  }
  init() {
    let centered_slides =
      this.sliderWrapper.dataset.centeredslides !== undefined ? JSON.parse(this.sliderWrapper.dataset.centeredslides) : undefined;
    let effect_fade =
      this.sliderWrapper.dataset.effectfade !== undefined
        ? JSON.parse(this.sliderWrapper.dataset.effectfade)
        : undefined;
    let next = this.querySelector(".swiper-button-next");
    let prev = this.querySelector(".swiper-button-prev");
    let pagination = this.querySelector(".swiper-pagination");

    // console.log("Tress", centered_slides);

    const slider = new Swiper(this.sliderWrapper, {
      effect: effect_fade ? "fade" : "slide",
      centeredSlides: centered_slides ? centered_slides : false,
      slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
      spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
      grabCursor: true,
      horizontal: true,
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
      loop: JSON.parse(this.sliderWrapper.dataset.loop),
      speed: 700,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: {
        enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
        disableOnInteraction: false,
        delay: parseInt(this.sliderWrapper.dataset.delay)
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      breakpoints: {
        359: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile),
          spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
        },
        768: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab),
          spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
        },
        1024: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop),
          spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
        },
      },
    });

    return slider;
  }
}
customElements.define("slideshow-swiper", slideshowSwiper);






class AutoSwiper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sliderWrapper = this.querySelector(".slideshow__swiper");
    if (!this.sliderWrapper) return;
    const resizeObserver = new ResizeObserver((entries) => this.init());
    resizeObserver.observe(this.sliderWrapper);
    //  console.log("testdd",this.sliderWrapper.dataset)
  }
  init() {
    let centered_slides =
      this.sliderWrapper.dataset.centeredslides !== undefined ? JSON.parse(this.sliderWrapper.dataset.centeredslides) : undefined;
    let effect_fade =
      this.sliderWrapper.dataset.effectfade !== undefined
        ? JSON.parse(this.sliderWrapper.dataset.effectfade)
        : undefined;
    let next = this.querySelector(".swiper-button-next");
    let prev = this.querySelector(".swiper-button-prev");
    let pagination = this.querySelector(".swiper-pagination");

    // console.log("Tress", centered_slides);

    const slider = new Swiper(this.sliderWrapper, {
      effect: effect_fade ? "fade" : "slide",
      centeredSlides: centered_slides ? centered_slides : false,
      slidesPerView: 'auto',
      grabCursor: true,
      horizontal: true,
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
      loop: JSON.parse(this.sliderWrapper.dataset.loop),
      speed: 700,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: {
        enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
        disableOnInteraction: false,
        delay: parseInt(this.sliderWrapper.dataset.delay)
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      pagination: {
        el: pagination,
        clickable: true,
      }
    });

    return slider;
  }
}
customElements.define("auto-swiper", AutoSwiper);

$('.buy-now').removeClass("loading");

$('.buy-now').on("click", function (e) {
  e.preventDefault();
  var form = $(this).closest("form");
  $(this).addClass("loading");
  var formParams = form.serialize();
   $.ajax({
    url: "/cart/add",
    type: "post",
    data: formParams,
    success: function(){
      $(this).removeClass("loading");
      window.location.href = "/checkout";
    },
    error: function(){
    }
   })

});






    function truncateHTMLContent(element, charLimit) {
        let content = element.innerHTML;
        let div = document.createElement("div");
        div.innerHTML = content;

        let totalChars = 0;
        let firstPart = "";
        let secondPart = "";

        function walk(node) {
            if (totalChars >= charLimit) {
                secondPart += node.outerHTML || node.textContent;
                return;
            }

            if (node.nodeType === Node.TEXT_NODE) {
                let text = node.textContent;
                if (totalChars + text.length <= charLimit) {
                    firstPart += text;
                    totalChars += text.length;
                } else {
                    let slice = text.slice(0, charLimit - totalChars);
                    firstPart += slice;
                    secondPart += text.slice(charLimit - totalChars);
                    totalChars = charLimit;
                }
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                let tempStart = `<${node.nodeName.toLowerCase()}`;
                [...node.attributes].forEach(attr => {
                    tempStart += ` ${attr.name}="${attr.value}"`;
                });
                tempStart += ">";

                let tempEnd = `</${node.nodeName.toLowerCase()}>`;

                let originalFirstPart = firstPart;
                firstPart += tempStart;
                for (let child of node.childNodes) {
                    walk(child);
                }
                firstPart += tempEnd;

                if (totalChars >= charLimit && originalFirstPart === firstPart) {
                    secondPart += node.outerHTML;
                }
            }
        }

        for (let node of div.childNodes) {
            walk(node);
        }

        return { firstPart, secondPart };
    }

    document.querySelectorAll(".add-read-more").forEach(function (element) {
        const charLimit = element.getAttribute("data-char-limit") ? parseInt(element.getAttribute("data-char-limit")) : 300;
        if (element.querySelector(".first-section")) return;

        const { firstPart, secondPart } = truncateHTMLContent(element, charLimit);

        if (secondPart.length > 0) {
            const plusSVG = `
                <svg class="icon-plus" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.49762 2.93384V14.0967" stroke="#334249" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2.9162 8.51532H14.0791" stroke="#334249" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`;

            const minusSVG = `
                <svg class="icon-minus" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.9162 8.51532H14.0791" stroke="#334249" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`;

            const strToAdd = `
                <span class="first-section">${firstPart}</span>
                <span class="second-section">${secondPart}</span>
                <span class="read-toggle">
                    <span class="toggle-text">Read more</span>
                    <span class="toggle-icon">${plusSVG}</span>
                </span>`;
            element.innerHTML = strToAdd;

            const toggle = element.querySelector(".read-toggle");
            const secondSection = element.querySelector(".second-section");
            const toggleText = toggle.querySelector(".toggle-text");
            const toggleIcon = toggle.querySelector(".toggle-icon");

            toggle.addEventListener("click", function () {
                const isExpanded = secondSection.style.display === "inline" || secondSection.style.display === "block";
                if (isExpanded) {
                    secondSection.style.display = "none";
                    toggleText.textContent = "Read more";
                    toggleIcon.innerHTML = plusSVG;
                } else {
                    secondSection.style.display = "block";
                    toggleText.textContent = "Read less";
                    toggleIcon.innerHTML = minusSVG;
                }
            });
        }
    });




    document.addEventListener("DOMContentLoaded", function() {
      const progressBars = document.querySelectorAll('.progress .progress-bar');
      progressBars.forEach(function(bar) {
        const valueNow = bar.getAttribute('aria-valuenow');

        if(valueNow != null){
          bar.style.width = valueNow + '%';
        }

      });
    });
    




    // const listItems = document.querySelectorAll('.layer-icon');
    // const desktopImage = document.querySelector('.layer-main_image .desktop__image');
    // const mobileImage = document.querySelector('.layer-main_image .mobile__image');
    
    // listItems.forEach(item => {
    //   const button = item.querySelector('button');
    
    //   if (button) {
    //     button.addEventListener('click', (e) => {
    //       e.stopPropagation();
    
    //       // Remove active class from all li
    //       listItems.forEach(li => li.classList.remove('active'));
    
    //       // Add active to clicked li
    //       item.classList.add('active');
    
    //       // Get new image URLs from button data attributes
    //       const newDesktopSrc = button.getAttribute('data-img-src');
    //       // const newDesktopSrcset = button.getAttribute('data-desktop-srcset');
    //       const newMobileSrc = button.getAttribute('data-mimg-src');
    //       // const newMobileSrcset = button.getAttribute('data-mobile-srcset');
    
    //       // Update images if available
    //       if (newDesktopSrc) {
    //         desktopImage.src = newDesktopSrc;
    //       }
    //       if (newDesktopSrc) {
    //         desktopImage.srcset = newDesktopSrc;
    //       }
    //       if (newMobileSrc) {
    //         mobileImage.src = newMobileSrc;
    //       }
    //       if (newMobileSrc) {
    //         mobileImage.srcset = newMobileSrc;
    //       }
    //     });
    //   }
    // });
    



    
// var sliderContent = new Swiper(".layer__slider", {
//   loop: true,
//   slidesPerView: "auto",
//   freeMode: false,
//   watchSlidesVisibility: true,
//   watchSlidesProgress: true,
//   allowTouchMove: true,
//   spaceBetween: 20,
//   navigation: {
//     nextEl: ".swiper-button-prev",
//     prevEl: ".swiper-button-next",
//   },
//   breakpoints: {
//     320: {
//       slidesPerView: 1,
//     },
//     1024: {
//       slidesPerView: "auto"
//     }
//   }
// });


// var sliderThumbnail = new Swiper('.layer-buttons', {
//   loop: true,
//   centeredSlides: true,
//   allowTouchMove: true,
//   direction: 'vertical',
//   slidesPerView: 'auto',
//   spaceBetween: 10,
//   effect: 'slide',
//   slideToClickedSlide: true
// });




// sliderThumbnail.controller.control = sliderContent;
// sliderContent.controller.control = sliderThumbnail;



 class LayerSlider extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;

    this._initialized = true;
    this._bindShopifyEvents();
    this.initSwiper();
  }

  disconnectedCallback() {
    this._destroySwiper();
    this._unbindShopifyEvents();
    this._initialized = false;
  }

  initSwiper() {
    const contentEl = this.querySelector(".layer__slider");
    const thumbEl = this.querySelector(".layer-buttons");

    if (!contentEl || !thumbEl || typeof Swiper === "undefined") return;

    this._destroySwiper();

    this.sliderContent = new Swiper(contentEl, {
      loop: false,
      slidesPerView: 1,
      freeMode: false,
      watchSlidesProgress: true,
      allowTouchMove: true,
      spaceBetween: 20,
      initialSlide: 0,
      speed: 400
    });

    this.sliderThumbnail = new Swiper(thumbEl, {
      loop: false,
      centeredSlides: true,
      allowTouchMove: true,
      direction: "vertical",
      slidesPerView: "auto",
      spaceBetween: 10,
      effect: "slide",
      slideToClickedSlide: true,
      initialSlide: 0,
      speed: 400
    });

    this.linkControllers();
    this.updateSwipers();
  }

  linkControllers() {
    const self = this;

    if (!this.sliderThumbnail || !this.sliderContent) return;

    this.sliderThumbnail.on("click", function (swiper) {
      const clicked = typeof swiper.clickedIndex === "number"
        ? swiper.clickedIndex
        : -1;

      if (clicked < 0 || self._syncing) return;

      self._syncing = true;
      self.sliderContent.slideTo(clicked);
      self.sliderThumbnail.slideTo(clicked);
      self._syncing = false;
    });

    this.sliderThumbnail.on("slideChange", function () {
      if (self._syncing) return;

      self._syncing = true;
      self.sliderContent.slideTo(self.sliderThumbnail.activeIndex);
      self._syncing = false;
    });

    this.sliderContent.on("slideChange", function () {
      if (self._syncing) return;

      self._syncing = true;
      self.sliderThumbnail.slideTo(self.sliderContent.activeIndex);
      self._syncing = false;
    });
  }

  updateSwipers() {
    this.sliderThumbnail?.update();
    this.sliderContent?.update();
  }

  refresh() {
    requestAnimationFrame(() => {
      this.initSwiper();
    });
  }

  _destroySwiper() {
    this.sliderContent?.destroy(true, true);
    this.sliderThumbnail?.destroy(true, true);

    this.sliderContent = null;
    this.sliderThumbnail = null;
    this._syncing = false;
  }

  _bindShopifyEvents() {
    this._onSectionLoad = (event) => {
      if (event.detail?.sectionId === this.closest(".shopify-section")?.id?.replace("shopify-section-", "")) {
        this.refresh();
      }
    };

    this._onBlockSelect = (event) => {
      if (this.contains(event.target)) {
        this.refresh();
      }
    };

    this._onBlockDeselect = (event) => {
      if (this.contains(event.target)) {
        this.refresh();
      }
    };

    document.addEventListener("shopify:section:load", this._onSectionLoad);
    document.addEventListener("shopify:block:select", this._onBlockSelect);
    document.addEventListener("shopify:block:deselect", this._onBlockDeselect);
  }

  _unbindShopifyEvents() {
    document.removeEventListener("shopify:section:load", this._onSectionLoad);
    document.removeEventListener("shopify:block:select", this._onBlockSelect);
    document.removeEventListener("shopify:block:deselect", this._onBlockDeselect);
  }
}

customElements.define("layer-slider", LayerSlider);


(function () {
  let galleryMode = "color";
  let sizeImagePinned = false;
  let pinnedColorMediaId = null;

  function getOptionScope(fieldset) {
    if (!fieldset) return null;

    const inPlace = fieldset.querySelector("[data-option-value]");
    if (inPlace) return fieldset;

    const toggle = fieldset.querySelector("[aria-controls]");
    const popover = toggle && document.getElementById(toggle.getAttribute("aria-controls"));
    return popover || fieldset;
  }

  function getSelectedOption(fieldset) {
    const scope = getOptionScope(fieldset);
    if (!scope) return null;

    const selected = scope.querySelector("[data-option-value][aria-selected='true']");
    if (selected) return selected;

    const hiddenInput = scope.querySelector('input[type="hidden"]');
    if (hiddenInput) {
      return Array.from(scope.querySelectorAll("[data-option-value]")).find(function (option) {
        return option.value === hiddenInput.value;
      }) || null;
    }

    return null;
  }

  function getClosedSwatchContainer(optionButton) {
    if (!optionButton) return null;

    const popover = optionButton.closest("x-popover");
    if (popover && popover.id) {
      const toggle = document.querySelector('[aria-controls="' + popover.id + '"]');
      const fromToggle = toggle && (
        toggle.querySelector(".select-value-image") ||
        (toggle.closest(".relative") && toggle.closest(".relative").querySelector(".select-value-image"))
      );
      if (fromToggle) return fromToggle;
    }

    const wrapper = optionButton.closest(".relative");
    return wrapper && wrapper.querySelector(".select-value-image");
  }

  function updateClosedSwatch(optionButton) {
    const container = getClosedSwatchContainer(optionButton);
    if (!container) return;

    const swatchBackground = optionButton.getAttribute("data-swatch-background");
    const imageUrl = optionButton.getAttribute("data-image");

    if (swatchBackground) {
      container.innerHTML = '<span class="select-value-swatch" style="--swatch-background: ' + swatchBackground + "; background: " + swatchBackground + ' center / cover;"></span>';
      return;
    }

    if (imageUrl) {
      container.innerHTML = '<img class="select-value-image__img" src="' + imageUrl + '" alt="' + (optionButton.getAttribute("data-image-alt") || optionButton.value || "") + '" width="40" height="40" loading="lazy">';
    }
  }

  function getOptionKind(option) {
    if (!option) return null;

    const kind = option.getAttribute("data-option-kind");
    if (kind === "size" || kind === "color") return kind;
    if (option.closest("[data-size-option]")) return "size";
    if (option.closest("[data-color-option]")) return "color";

    const popover = option.closest("x-popover");
    if (popover && popover.id) {
      const toggle = document.querySelector('[aria-controls="' + popover.id + '"]');
      const fieldset = toggle && toggle.closest("fieldset");
      if (fieldset) {
        if (fieldset.hasAttribute("data-size-option")) return "size";
        if (fieldset.hasAttribute("data-color-option")) return "color";
      }
    }

    if (option.hasAttribute("data-gallery-image")) return "size";
    if (option.hasAttribute("data-swatch-background") || option.hasAttribute("data-featured-media-id")) return "color";
    return null;
  }

  function isVariantPickerOption(option) {
    if (!option || !option.hasAttribute("data-option-value")) return false;
    if (option.closest("variant-picker")) return true;

    const popover = option.closest("x-popover");
    if (!popover || !popover.id) return false;
    const toggle = document.querySelector('[aria-controls="' + popover.id + '"]');
    return !!(toggle && toggle.closest("variant-picker"));
  }

  function getGallery() {
    return document.querySelector("product-gallery");
  }

  function getCarousel() {
    return document.querySelector("product-gallery media-carousel");
  }

  function getCustomSlide() {
    return document.querySelector(".product-gallery__media.custom-meta-image");
  }

  function getCarouselItems(carousel) {
    if (!carousel) return [];
    return Array.from(carousel.children);
  }

  function ensureFirstImageHidden() {
    const gallery = getGallery();
    if (!gallery || !gallery.hasAttribute("data-hide-first-image")) return;

    gallery.querySelectorAll("[data-first-product-image]").forEach(function (el) {
      el.hidden = true;
    });
  }

  function ensureColorVariantVisible(mediaId) {
    if (!mediaId) return;

    const id = String(mediaId);
    pinnedColorMediaId = id;

    const carousel = getCarousel();
    const items = getCarouselItems(carousel);
    const slideIndex = items.findIndex(function (item) {
      return item.getAttribute("data-media-id") === id;
    });

    if (slideIndex >= 0 && items[slideIndex] && !items[slideIndex].hasAttribute("data-first-product-image")) {
      items[slideIndex].hidden = false;
      items[slideIndex].removeAttribute("hidden");
    }

    document.querySelectorAll("product-gallery page-dots").forEach(function (dots) {
      Array.from(dots.children).forEach(function (thumb, thumbIndex) {
        const isPinned = thumb.classList.contains("thumbnail-list_item--variant") && thumbIndex === slideIndex;
        thumb.classList.toggle("is-pinned-color-variant", isPinned);
        if (isPinned) {
          thumb.hidden = false;
          thumb.removeAttribute("hidden");
        }
      });
    });
  }

  function syncSizeThumbnails(option, visible) {
    const galleryUrl = option && (option.getAttribute("data-gallery-image") || option.getAttribute("data-image"));
    const thumbUrl = option && (option.getAttribute("data-image") || option.getAttribute("data-gallery-image"));
    const alt = option && (option.getAttribute("data-gallery-image-alt") || option.value || "");

    document.querySelectorAll("[data-custom-meta-thumb]").forEach(function (thumb) {
      thumb.hidden = !visible;
      if (!visible) {
        thumb.setAttribute("aria-current", "false");
        return;
      }

      const img = thumb.querySelector("img");
      if (img && (thumbUrl || galleryUrl)) {
        img.hidden = false;
        img.removeAttribute("hidden");
        img.src = thumbUrl || galleryUrl;
        img.alt = alt;
      }
    });
  }

  function syncThumbCurrent(index) {
    document.querySelectorAll("product-gallery page-dots").forEach(function (dots) {
      Array.from(dots.children).forEach(function (item, itemIndex) {
        if (item.hidden && !item.classList.contains("is-pinned-color-variant")) return;
        item.setAttribute("aria-current", itemIndex === index ? "true" : "false");
      });
    });

    if (pinnedColorMediaId) {
      ensureColorVariantVisible(pinnedColorMediaId);
    }
  }

  function goToSlide(slide) {
    const carousel = getCarousel();
    if (!carousel || !slide) return;

    const items = getCarouselItems(carousel);
    const index = items.indexOf(slide);
    if (index < 0) return;

    items.forEach(function (item, itemIndex) {
      item.classList.toggle("is-selected", itemIndex === index);
    });

    if (typeof carousel.select === "function") {
      carousel.select(index, { animate: false, force: true });
    }

    if (carousel.scrollWidth > carousel.clientWidth + 1) {
      const centered = getComputedStyle(slide).scrollSnapAlign === "center";
      const left = centered
        ? slide.offsetLeft - carousel.clientWidth / 2 + slide.clientWidth / 2
        : slide.offsetLeft;
      carousel.scrollTo({ left: Math.max(0, left), behavior: "auto" });
    }

    syncThumbCurrent(index);
  }

  function updateSizeSlideContent(option) {
    const slide = getCustomSlide();
    const galleryUrl = option && option.getAttribute("data-gallery-image");
    if (!slide || !galleryUrl) return false;

    const img = slide.querySelector("img.custom-meta-image__img") || slide.querySelector("img");
    if (img) {
      img.hidden = false;
      img.removeAttribute("hidden");
      img.src = galleryUrl;
      img.srcset = option.getAttribute("data-gallery-image-srcset") || "";
      img.alt = option.getAttribute("data-gallery-image-alt") || option.value || "";

      const width = option.getAttribute("data-gallery-image-width");
      const height = option.getAttribute("data-gallery-image-height");
      if (width) img.setAttribute("width", width);
      if (height) img.setAttribute("height", height);
    }

    slide.hidden = false;
    slide.removeAttribute("hidden");
    syncSizeThumbnails(option, true);
    return true;
  }

  function showSizeImage(option) {
    if (!updateSizeSlideContent(option)) return;

    sizeImagePinned = true;
    if (pinnedColorMediaId) {
      ensureColorVariantVisible(pinnedColorMediaId);
    } else {
      const selectedColor = getSelectedOption(document.querySelector("variant-picker [data-color-option]"));
      if (selectedColor && selectedColor.getAttribute("data-featured-media-id")) {
        ensureColorVariantVisible(selectedColor.getAttribute("data-featured-media-id"));
      }
    }

    const slide = getCustomSlide();
    void slide.offsetWidth;
    goToSlide(slide);
  }

  function showColorImage(variant, mediaId) {
    const slide = getCustomSlide();
    if (slide) {
      slide.classList.remove("is-selected");
      if (!sizeImagePinned) {
        slide.hidden = true;
        syncSizeThumbnails(null, false);
      }
    }

    ensureFirstImageHidden();

    const carousel = getCarousel();
    if (!carousel) return;

    const items = getCarouselItems(carousel);
    const id = mediaId || (variant && variant.featured_media && String(variant.featured_media.id));
    let target = null;

    if (id) {
      target = items.find(function (item) {
        return item.getAttribute("data-media-id") === String(id);
      });
    }

    if (!target && variant && variant.featured_media && variant.featured_media.position) {
      target = items[variant.featured_media.position - 1];
    }

    if (!target) {
      target = items.find(function (item) {
        return !item.classList.contains("custom-meta-image") && !item.hidden && !item.hasAttribute("data-first-product-image");
      });
    }

    if (target && target.hasAttribute("data-first-product-image") && target.hidden) {
      target = items.find(function (item) {
        return !item.classList.contains("custom-meta-image") && !item.hidden && !item.hasAttribute("data-first-product-image");
      });
    }

    if (!target) return;

    target.hidden = false;
    const colorId = target.getAttribute("data-media-id") || id;
    if (colorId) {
      ensureColorVariantVisible(colorId);
    }

    void target.offsetWidth;
    goToSlide(target);
  }

  function setGalleryMode(mode) {
    galleryMode = mode;
    document.querySelectorAll("product-gallery").forEach(function (gallery) {
      gallery.setAttribute("data-gallery-mode", mode);
    });
  }

  function applyGalleryMode(variant) {
    ensureFirstImageHidden();

    if (galleryMode === "size") {
      showSizeImage(getSelectedOption(document.querySelector("variant-picker [data-size-option]")));
      return;
    }

    if (sizeImagePinned) {
      updateSizeSlideContent(getSelectedOption(document.querySelector("variant-picker [data-size-option]")));
    }

    showColorImage(variant);
  }

  function setModeFromOption(option) {
    if (!isVariantPickerOption(option)) return;

    const kind = getOptionKind(option);
    if (kind === "size") {
      setGalleryMode("size");
      updateClosedSwatch(option);
      showSizeImage(option);
      return;
    }

    if (kind === "color") {
      setGalleryMode("color");
      updateClosedSwatch(option);
      showColorImage(null, option.getAttribute("data-featured-media-id"));
    }
  }

  function bindPickerClicks() {
    document.addEventListener("listbox:select", function (event) {
      setModeFromOption(event.target.closest("[data-option-value]") || event.target);
    });

    document.addEventListener("listbox:change", function (event) {
      setModeFromOption(event.target.closest("[data-option-value]") || event.target);
    });

    document.addEventListener("click", function (event) {
      setModeFromOption(event.target.closest("[data-option-value]"));
    }, true);

    document.addEventListener("variant:change", function (event) {
      const variant = event.detail && event.detail.variant;
      const product = event.detail && event.detail.product;
      const selectedColor = getSelectedOption(document.querySelector("variant-picker [data-color-option]"));
      const selectedSize = getSelectedOption(document.querySelector("variant-picker [data-size-option]"));

      if (selectedColor) updateClosedSwatch(selectedColor);
      if (selectedSize) updateClosedSwatch(selectedSize);

      reorderOptionValuesToShopifyOrder(product, variant);

      if (galleryMode === "color" && variant && variant.featured_media) {
        ensureColorVariantVisible(variant.featured_media.id);
      } else if (galleryMode === "size" && pinnedColorMediaId) {
        ensureColorVariantVisible(pinnedColorMediaId);
      } else if (selectedColor && selectedColor.getAttribute("data-featured-media-id")) {
        ensureColorVariantVisible(selectedColor.getAttribute("data-featured-media-id"));
      }

      requestAnimationFrame(function () {
        applyGalleryMode(variant);
        requestAnimationFrame(function () {
          applyGalleryMode(variant);
          ensureFirstImageHidden();
          if (pinnedColorMediaId) ensureColorVariantVisible(pinnedColorMediaId);
        });
      });
    });

    ensureFirstImageHidden();

    const initialColor = getSelectedOption(document.querySelector("variant-picker [data-color-option]"));
    if (initialColor && initialColor.getAttribute("data-featured-media-id")) {
      ensureColorVariantVisible(initialColor.getAttribute("data-featured-media-id"));
    }
  }

  /**
   * Keep option lists in Shopify admin variant order for the current selection.
   * Uses CSS order (not DOM moves) so Impact's index-based sold-out logic stays correct.
   * Needed when option values differ per colour (e.g. Double dimensions) and unique
   * option.values order no longer matches each colour group.
   */
  function reorderOptionValuesToShopifyOrder(product, variant) {
    if (!product || !variant || !product.variants || !product.variants.length) return;

    const picker = document.querySelector("variant-picker");
    if (!picker) return;

    const optionSelectors = Array.from(picker.querySelectorAll("[data-option-selector]"));
    if (optionSelectors.length < 2) return;

    for (var optionIndex = 1; optionIndex < optionSelectors.length; optionIndex++) {
      var optionKey = "option" + (optionIndex + 1);
      var orderMap = {};
      var rank = 0;

      product.variants.forEach(function (v) {
        var matches = true;
        for (var prev = 1; prev <= optionIndex; prev++) {
          if (v["option" + prev] !== variant["option" + prev]) {
            matches = false;
            break;
          }
        }
        if (!matches) return;

        var value = v[optionKey];
        if (value == null || orderMap[value] !== undefined) return;
        orderMap[value] = rank++;
      });

      var selector = optionSelectors[optionIndex];
      selector.classList.add("variant-picker__option-values--shopify-order");

      Array.from(selector.querySelectorAll("[data-option-value]")).forEach(function (el) {
        var value = el.value != null && el.value !== "" ? el.value : el.getAttribute("value");
        el.style.order = orderMap[value] !== undefined ? String(orderMap[value]) : "999";
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindPickerClicks);
  } else {
    bindPickerClicks();
  }
})();


// class LayerSlider extends HTMLElement {
//   connectedCallback() {
//     this.initSwiper();
//   }

//   initSwiper() {
//     const sliderContent = new Swiper(this.querySelector(".layer__slider"), {
//       loop: true,
//       slidesPerView: "auto",
//       freeMode: false,
//       watchSlidesVisibility: true,
//       watchSlidesProgress: true,
//       allowTouchMove: true,
//       spaceBetween: 20,
//       navigation: {
//         nextEl: this.querySelector(".swiper-button-next"),
//         prevEl: this.querySelector(".swiper-button-prev"),
//       },
//       breakpoints: {
//         320: {
//           slidesPerView: 1,
//         },
//         1024: {
//           slidesPerView: "auto"
//         }
//       }
//     });

//     const sliderThumbnail = new Swiper(this.querySelector(".layer-buttons"), {
//       loop: true,
//       centeredSlides: true,
//       allowTouchMove: true,
//       direction: 'vertical',
//       slidesPerView: 'auto',
//       spaceBetween: 10,
//       effect: 'slide',
//       slideToClickedSlide: true
//     });

//     sliderThumbnail.controller.control = sliderContent;
//     sliderContent.controller.control = sliderThumbnail;
//   }
// }

// customElements.define('layer-slider', LayerSlider);

(function () {
  function parseMoneyToCents(text) {
    if (!text) return null;
    var cleaned = String(text).replace(/[^\d.,]/g, "").trim();
    if (!cleaned) return null;

    var hasComma = cleaned.indexOf(",") > -1;
    var hasDot = cleaned.indexOf(".") > -1;

    if (hasComma && hasDot) {
      if (cleaned.lastIndexOf(",") > cleaned.lastIndexOf(".")) {
        cleaned = cleaned.replace(/\./g, "").replace(",", ".");
      } else {
        cleaned = cleaned.replace(/,/g, "");
      }
    } else if (hasComma) {
      cleaned = cleaned.replace(",", ".");
    }

    var value = parseFloat(cleaned);
    if (isNaN(value)) return null;
    return Math.round(value * 100);
  }

  function formatMoney(cents, banner) {
    var useCurrency = banner.getAttribute("data-currency-code-enabled") === "true";
    var format = useCurrency
      ? banner.getAttribute("data-money-with-currency-format")
      : banner.getAttribute("data-money-format");

    function cleanMoney(value) {
      return String(value || "")
        .replace(/Â£/g, "\u00A3")
        .replace(/&pound;/gi, "\u00A3")
        .replace(/&#163;/g, "\u00A3");
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === "function" && format) {
      return cleanMoney(window.Shopify.formatMoney(cents, cleanMoney(format)));
    }

    var amount = (Math.max(0, cents) / 100).toFixed(2);
    return "\u00A3" + amount;
  }

  function getDisplayedProductPriceCents() {
    var salePrice = document.querySelector(".product-info__price sale-price, .product-info__price .price-list sale-price, price-list sale-price");
    if (salePrice) {
      var cents = parseMoneyToCents(salePrice.textContent);
      if (cents != null) return cents;
    }

    var priceList = document.querySelector(".product-info__price .price-list, .product-info__price");
    if (priceList) {
      return parseMoneyToCents(priceList.textContent);
    }

    return null;
  }

  function renderBanner(banner, totalCents) {
    if (!banner || totalCents == null || isNaN(totalCents)) return;

    var divider = parseFloat(banner.getAttribute("data-divider")) || 3;
    if (divider < 1) divider = 3;

    var installmentCents = Math.floor(totalCents / divider);
    var money = formatMoney(installmentCents, banner);
    var template = banner.getAttribute("data-line-1-template") || "3 payments of [amount] at 0% interest with Klarna";
    var amountHtml = '<strong class="installment-banner__amount">' + money + "</strong>";
    var line = banner.querySelector("[data-installment-line-1]");
    if (!line) return;

    line.innerHTML = template
      .replace(/\[amount\]/gi, amountHtml)
      .replace(/\{\{\s*amount\s*\}\}/gi, amountHtml);
  }

  function updateAllBanners(totalCents) {
    var cents = totalCents != null ? totalCents : getDisplayedProductPriceCents();
    document.querySelectorAll("[data-installment-banner]").forEach(function (banner) {
      renderBanner(banner, cents);
    });
  }

  function bindInstallmentBanners() {
    if (!document.querySelector("[data-installment-banner]")) return;

    updateAllBanners();

    document.addEventListener("variant:change", function (event) {
      var variant = event.detail && event.detail.variant;
      if (variant && typeof variant.price === "number") {
        // Prefer live DOM price shortly after GPO/add-ons settle; fall back to variant price.
        requestAnimationFrame(function () {
          var live = getDisplayedProductPriceCents();
          updateAllBanners(live != null ? live : variant.price);
        });
        setTimeout(function () {
          updateAllBanners(getDisplayedProductPriceCents());
        }, 300);
        return;
      }
      updateAllBanners();
    });

    var priceRoot = document.querySelector(".product-info__price, .product-info");
    if (priceRoot && window.MutationObserver) {
      var timer = null;
      var observer = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          updateAllBanners(getDisplayedProductPriceCents());
        }, 50);
      });
      observer.observe(priceRoot, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    document.addEventListener("change", function (event) {
      if (!event.target) return;
      if (
        event.target.closest(".gpo-app") ||
        event.target.closest("[data-gpo]") ||
        event.target.name === "quantity" ||
        event.target.closest("quantity-selector")
      ) {
        setTimeout(function () {
          updateAllBanners(getDisplayedProductPriceCents());
        }, 150);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindInstallmentBanners);
  } else {
    bindInstallmentBanners();
  }
})();

(function () {
  var syncingNote = false;
  var UK_TIMEZONE = "Europe/London";
  var MONTH_NAMES = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function getTimezone(picker) {
    return (picker && picker.getAttribute("data-timezone")) || UK_TIMEZONE;
  }

  function getZonedDateParts(timeZone) {
    var formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone: timeZone || UK_TIMEZONE,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
    var parts = formatter.formatToParts(new Date());
    var map = {};
    parts.forEach(function (part) {
      if (part.type !== "literal") map[part.type] = part.value;
    });
    return {
      year: Number(map.year),
      month: Number(map.month),
      day: Number(map.day)
    };
  }

  function todayIso(picker) {
    var parts = getZonedDateParts(getTimezone(picker));
    return parts.year + "-" + pad(parts.month) + "-" + pad(parts.day);
  }

  function addDaysIso(iso, days) {
    var parts = String(iso).split("-");
    // Date-only math in UTC avoids DST shifting calendar days.
    var date = new Date(Date.UTC(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])));
    date.setUTCDate(date.getUTCDate() + (days || 0));
    return date.getUTCFullYear() + "-" + pad(date.getUTCMonth() + 1) + "-" + pad(date.getUTCDate());
  }

  function parseIso(iso) {
    var parts = String(iso || "").split("-");
    if (parts.length !== 3) return null;
    var date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    return isNaN(date.getTime()) ? null : date;
  }

  function getMinDateForPicker(picker) {
    var disableUpcoming = picker && picker.getAttribute("data-disable-upcoming") === "true";
    var disabledDays = parseInt(picker && picker.getAttribute("data-disabled-days"), 10);
    var ukToday = todayIso(picker);

    if (disableUpcoming && !isNaN(disabledDays) && disabledDays > 0) {
      return addDaysIso(ukToday, disabledDays);
    }
    return ukToday;
  }

  function formatDisplayDate(iso) {
    var date = parseIso(iso);
    if (!date) return iso || "";
    try {
      return date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric"
      });
    } catch (e) {
      return iso;
    }
  }

  function formatBarDate(iso) {
    var parts = String(iso || "").split("-");
    if (parts.length !== 3) return "mm/dd/yyyy";
    return parts[1] + "/" + parts[2] + "/" + parts[0];
  }

  function updateDisplay(picker) {
    var input = picker.querySelector("[data-delivery-date-input]");
    var display = picker.querySelector("[data-delivery-date-display]");
    var selected = picker.querySelector("[data-delivery-date-selected]");
    var label = picker.querySelector("[data-delivery-date-selected-label]");
    var error = picker.querySelector("[data-delivery-date-error]");
    var control = picker.querySelector(".delivery-date-picker__control");
    if (!input || !display) return;

    if (control) control.classList.toggle("has-value", Boolean(input.value));

    if (input.value) {
      display.textContent = formatBarDate(input.value);
      display.classList.remove("is-placeholder");
      if (selected && label) {
        var propertyName = picker.getAttribute("data-property-name") || "Delivery Date";
        label.textContent = propertyName + ": " + formatDisplayDate(input.value);
        selected.hidden = false;
      }
      picker.classList.remove("is-invalid");
      if (error) error.hidden = true;
    } else {
      display.textContent = "mm/dd/yyyy";
      display.classList.add("is-placeholder");
      if (selected) selected.hidden = true;
      if (label) label.textContent = "";
    }
  }

  function enforceMinDate(input, picker) {
    if (!input) return;
    var root = picker || input.closest("[data-delivery-date-picker]");
    var min = getMinDateForPicker(root);
    input.setAttribute("data-min-date", min);
    if (root) root.setAttribute("data-min-date", min);
    if (input.value && input.value < min) {
      input.value = "";
      if (root) {
        updateDisplay(root);
        syncDeliveryPropertyToForm(root);
      }
    }
  }

  function getPropertyName(picker) {
    return (picker && picker.getAttribute("data-property-name")) || "Delivery Date";
  }

  function getCartRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
  }

  function rememberDeliveryDate(propertyName, value) {
    try {
      if (value) {
        sessionStorage.setItem("ddp:" + propertyName, value);
        localStorage.setItem("ddp:" + propertyName, value);
        sessionStorage.setItem("ddp:__last", value);
        localStorage.setItem("ddp:__last", value);
        if (propertyName) {
          sessionStorage.setItem("ddp:__propertyName", propertyName);
          localStorage.setItem("ddp:__propertyName", propertyName);
        }
      } else {
        sessionStorage.removeItem("ddp:" + propertyName);
        localStorage.removeItem("ddp:" + propertyName);
      }
    } catch (e) {}
  }

  function recallDeliveryDate(propertyName) {
    try {
      return (
        sessionStorage.getItem("ddp:" + propertyName) ||
        localStorage.getItem("ddp:" + propertyName) ||
        sessionStorage.getItem("ddp:__last") ||
        localStorage.getItem("ddp:__last") ||
        ""
      );
    } catch (e) {
      return "";
    }
  }

  function recallStoredPropertyName() {
    try {
      return (
        sessionStorage.getItem("ddp:__propertyName") ||
        localStorage.getItem("ddp:__propertyName") ||
        ""
      );
    } catch (e) {
      return "";
    }
  }

  function findDeliveryFromAttributes(attrs) {
    if (!attrs) return { propertyName: "", value: "" };
    var keys = Object.keys(attrs);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (!key || key === "ddp_tag" || !attrs[key]) continue;
      if (key.toLowerCase().indexOf("delivery") === -1) continue;
      return { propertyName: key, value: String(attrs[key]) };
    }
    return { propertyName: "", value: "" };
  }

  function recallDeliveryDateFromNote(note) {
    var match = String(note || "").match(/(Delivery(?:\s+\w+){0,3})\s*:\s*([^\n]+)/i);
    if (!match) return { propertyName: "", value: "" };
    return { propertyName: match[1].trim(), value: match[2].trim() };
  }

  function isoFromLooseDate(value) {
    if (!value) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    var parsed = Date.parse(value);
    if (isNaN(parsed)) return "";
    var date = new Date(parsed);
    return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate());
  }

  function toPropertyDisplayValue(isoOrText) {
    if (!isoOrText) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(isoOrText)) return formatDisplayDate(isoOrText);
    return isoOrText;
  }

  function getSelectedDeliveryDate(picker) {
    var propertyName = picker ? getPropertyName(picker) : "Delivery Date";
    var input = picker && picker.querySelector("[data-delivery-date-input]");
    if (input && input.value) return input.value;
    var remembered = recallDeliveryDate(propertyName);
    if (remembered) return remembered;
    return "";
  }

  function findPropertyValue(properties, propertyName) {
    if (!properties) return "";
    if (properties[propertyName]) return properties[propertyName];
    var keys = Object.keys(properties);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i] && keys[i].toLowerCase() === String(propertyName).toLowerCase()) {
        return properties[keys[i]];
      }
      if (keys[i] && keys[i].toLowerCase().indexOf("delivery") > -1 && properties[keys[i]]) {
        return properties[keys[i]];
      }
    }
    return "";
  }

  function findMainProductLine(cart, propertyName) {
    var items = (cart && cart.items) || [];
    if (!items.length) return null;

    var ranked = items.slice().sort(function (a, b) {
      var ap = a.properties || {};
      var bp = b.properties || {};
      var aScore = (ap._has_gpo || ap._gpo_product_group ? 10 : 0) + Object.keys(ap).length;
      var bScore = (bp._has_gpo || bp._gpo_product_group ? 10 : 0) + Object.keys(bp).length;
      return bScore - aScore;
    });

    var missing = ranked.find(function (item) {
      return item && item.key && !findPropertyValue(item.properties, propertyName);
    });
    return missing || ranked[0] || null;
  }

  function syncDeliveryPropertyToForm(picker) {
    var input = picker.querySelector("[data-delivery-date-input]");
    if (!input) return;

    var propertyName = getPropertyName(picker);
    var formId = input.getAttribute("form");
    var form = formId ? document.getElementById(formId) : input.closest("form");
    var displayValue = input.value ? toPropertyDisplayValue(input.value) : "";

    if (form) {
      var syncInput = form.querySelector("[data-delivery-date-form-sync]");
      if (!syncInput) {
        syncInput = document.createElement("input");
        syncInput.type = "hidden";
        syncInput.setAttribute("data-delivery-date-form-sync", "true");
        form.insertBefore(syncInput, form.firstChild);
      }
      syncInput.name = "properties[" + propertyName + "]";
      if (displayValue) {
        syncInput.value = displayValue;
        syncInput.disabled = false;
      } else {
        syncInput.value = "";
        syncInput.disabled = true;
      }
    }

    // Globo Product Options serializes fields inside .gpo-app — inject there too.
    var gpoRoot = document.querySelector(".gpo-app, [data-gpo], .globo-formbuilder, #gpo-app");
    if (gpoRoot) {
      var gpoSync = gpoRoot.querySelector("[data-delivery-date-gpo-sync]");
      if (!gpoSync) {
        gpoSync = document.createElement("input");
        gpoSync.type = "hidden";
        gpoSync.setAttribute("data-delivery-date-gpo-sync", "true");
        gpoRoot.appendChild(gpoSync);
      }
      gpoSync.name = "properties[" + propertyName + "]";
      gpoSync.value = displayValue || "";
      gpoSync.disabled = !displayValue;
    }

    input.removeAttribute("name");
    rememberDeliveryDate(propertyName, input.value || "");
  }

  function getActiveDeliverySelection() {
    var picker = document.querySelector("[data-delivery-date-picker]");
    var propertyName =
      (picker ? getPropertyName(picker) : "") ||
      recallStoredPropertyName() ||
      "Delivery Date";
    var selected = picker ? getSelectedDeliveryDate(picker) : recallDeliveryDate(propertyName);
    return {
      propertyName: propertyName,
      value: selected,
      displayValue: selected ? toPropertyDisplayValue(selected) : ""
    };
  }

  function injectDeliveryIntoBody(body, propertyName, propertyValue, url) {
    if (!propertyValue || body == null) return body;
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(String(url || ""));
    var isChange = /\/cart\/change(\.js)?(\?|$)/.test(String(url || ""));

    if (typeof FormData !== "undefined" && body instanceof FormData) {
      body.set("properties[" + propertyName + "]", propertyValue);
      return body;
    }

    if (typeof body === "string") {
      try {
        var json = JSON.parse(body);

        if (Array.isArray(json.items)) {
          json.items.forEach(function (item) {
            item.properties = item.properties || {};
            var ordered = {};
            ordered[propertyName] = propertyValue;
            Object.keys(item.properties).forEach(function (key) {
              ordered[key] = item.properties[key];
            });
            item.properties = ordered;
          });
          return JSON.stringify(json);
        }

        // Only merge into an existing properties object, or create one for cart/add.
        // Never send properties-only on cart/change (would wipe GPO options).
        if (json.properties || isAdd) {
          json.properties = json.properties || {};
          var orderedProps = {};
          orderedProps[propertyName] = propertyValue;
          Object.keys(json.properties).forEach(function (key) {
            if (key !== propertyName) orderedProps[key] = json.properties[key];
          });
          json.properties = orderedProps;
          return JSON.stringify(json);
        }

        if (isChange) return body;
        return JSON.stringify(json);
      } catch (e) {
        var params = new URLSearchParams(body);
        params.set("properties[" + propertyName + "]", propertyValue);
        return params.toString();
      }
    }

    return body;
  }

  function patchCartNetwork() {
    if (window.__ddpNetworkPatched) return;
    window.__ddpNetworkPatched = true;

    function maybePatch(url, body) {
      if (!url || !/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(String(url))) return body;
      document.querySelectorAll("[data-delivery-date-picker]").forEach(syncDeliveryPropertyToForm);
      var selection = getActiveDeliverySelection();
      if (!selection.displayValue) return body;
      return injectDeliveryIntoBody(body, selection.propertyName, selection.displayValue, url);
    }

    function queueRepair() {
      if (ddpInternalCartWrite || syncingDeliveryProperty) return;
      setTimeout(function () {
        if (ddpInternalCartWrite) return;
        fetch(getCartRoot() + "cart.js", { credentials: "same-origin" })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            return ensureDeliveryPropertyWithRetry(cart).then(function (next) {
              updateCartNoteFromCart(next || cart);
            });
          })
          .catch(function () {});
      }, 350);
    }

    if (typeof window.fetch === "function") {
      var originalFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        try {
          var url = typeof input === "string" ? input : input && input.url;
          init = init ? Object.assign({}, init) : {};
          if (init.body != null) init.body = maybePatch(url, init.body);
          return originalFetch(input, init).then(function (response) {
            if (url && /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(String(url))) queueRepair();
            return response;
          });
        } catch (e) {
          return originalFetch(input, init);
        }
      };
    }

    if (typeof XMLHttpRequest !== "undefined") {
      var originalOpen = XMLHttpRequest.prototype.open;
      var originalSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__ddpUrl = url;
        return originalOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function (body) {
        try {
          body = maybePatch(this.__ddpUrl, body);
        } catch (e) {}
        if (this.__ddpUrl && /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(String(this.__ddpUrl))) {
          this.addEventListener("load", queueRepair);
        }
        return originalSend.call(this, body);
      };
    }
  }

  var syncingDeliveryProperty = false;
  var ddpInternalCartWrite = false;

  function updateLineItemProperties(lineKey, quantity, properties) {
    ddpInternalCartWrite = true;
    return fetch(getCartRoot() + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        properties: properties
      })
    })
      .then(function (res) {
        return res.json();
      })
      .finally(function () {
        setTimeout(function () {
          ddpInternalCartWrite = false;
        }, 50);
      });
  }

  function resolveSelectedDate(cart) {
    var picker = document.querySelector("[data-delivery-date-picker]");
    var propertyName =
      (picker ? getPropertyName(picker) : "") ||
      recallStoredPropertyName() ||
      "Delivery Date";
    var selected = picker ? getSelectedDeliveryDate(picker) : recallDeliveryDate(propertyName);
    if (selected) {
      rememberDeliveryDate(propertyName, selected);
      return { propertyName: propertyName, value: selected };
    }

    var fromAttrs = findDeliveryFromAttributes(cart && cart.attributes);
    if (fromAttrs.value) {
      rememberDeliveryDate(fromAttrs.propertyName || propertyName, fromAttrs.value);
      return {
        propertyName: fromAttrs.propertyName || propertyName,
        value: fromAttrs.value
      };
    }

    var fromNote = recallDeliveryDateFromNote(cart && cart.note);
    if (fromNote.value) {
      var asIso = isoFromLooseDate(fromNote.value);
      var name = fromNote.propertyName || propertyName;
      rememberDeliveryDate(name, asIso || fromNote.value);
      return {
        propertyName: name,
        value: asIso || fromNote.value
      };
    }

    // Last resort: any delivery property already on a line item.
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        var props = cart.items[i].properties || {};
        var keys = Object.keys(props);
        for (var k = 0; k < keys.length; k++) {
          if (keys[k] && keys[k].toLowerCase().indexOf("delivery") > -1 && props[keys[k]]) {
            return { propertyName: keys[k], value: props[keys[k]] };
          }
        }
      }
    }

    return { propertyName: propertyName, value: "" };
  }

  function cartHasDeliveryProperty(cart, propertyName) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return !!findPropertyValue(item.properties, propertyName);
    });
  }

  function ensureDeliveryPropertyOnItems(cart, itemsToFix) {
    if (!cart) return Promise.resolve(cart);

    // If another repair is in flight, wait and retry instead of dropping the write.
    if (syncingDeliveryProperty) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          fetch(getCartRoot() + "cart.js", { credentials: "same-origin" })
            .then(function (res) {
              return res.json();
            })
            .then(function (fresh) {
              return ensureDeliveryPropertyOnItems(fresh, itemsToFix);
            })
            .then(resolve)
            .catch(function () {
              resolve(cart);
            });
        }, 450);
      });
    }

    var resolved = resolveSelectedDate(cart);
    var propertyName = resolved.propertyName;
    var selected = resolved.value;
    if (!selected) return Promise.resolve(cart);

    var propertyValue = toPropertyDisplayValue(selected);
    var targets = itemsToFix && itemsToFix.length ? itemsToFix.slice() : [];

    if (!targets.length) {
      var main = findMainProductLine(cart, propertyName);
      if (main) targets = [main];
    }

    var updates = [];

    targets.forEach(function (item) {
      if (!item) return;
      var line = item;
      if (!line.key && cart.items && cart.items.length) {
        line =
          cart.items.find(function (ci) {
            return String(ci.key) === String(item.key) || String(ci.id) === String(item.id) || String(ci.variant_id) === String(item.id);
          }) || item;
      }
      if (!line.key) return;

      var props = Object.assign({}, line.properties || {});
      if (findPropertyValue(props, propertyName)) return;

      // Put delivery property first so it stays visible in admin line properties.
      var ordered = {};
      ordered[propertyName] = propertyValue;
      Object.keys(props).forEach(function (key) {
        ordered[key] = props[key];
      });

      updates.push(updateLineItemProperties(line.key, line.quantity, ordered));
    });

    if (!updates.length) return Promise.resolve(cart);

    syncingDeliveryProperty = true;
    return Promise.all(updates)
      .then(function () {
        return fetch(getCartRoot() + "cart.js", { credentials: "same-origin" }).then(function (res) {
          return res.json();
        });
      })
      .catch(function () {
        return cart;
      })
      .finally(function () {
        syncingDeliveryProperty = false;
      });
  }

  function ensureDeliveryPropertyWithRetry(cart, attemptsLeft) {
    var attempts = typeof attemptsLeft === "number" ? attemptsLeft : 4;
    return ensureDeliveryPropertyOnItems(cart).then(function (nextCart) {
      var live = nextCart || cart;
      var resolved = resolveSelectedDate(live);
      if (!resolved.value) return live;
      if (cartHasDeliveryProperty(live, resolved.propertyName) || attempts <= 1) return live;

      return new Promise(function (resolve) {
        setTimeout(function () {
          fetch(getCartRoot() + "cart.js", { credentials: "same-origin" })
            .then(function (res) {
              return res.json();
            })
            .then(function (fresh) {
              return ensureDeliveryPropertyWithRetry(fresh, attempts - 1);
            })
            .then(resolve)
            .catch(function () {
              resolve(live);
            });
        }, 550);
      });
    });
  }

  function validatePicker(picker) {
    var input = picker.querySelector("[data-delivery-date-input]");
    var error = picker.querySelector("[data-delivery-date-error]");
    var trigger = picker.querySelector("[data-delivery-date-trigger]");
    var required = picker.getAttribute("data-required") === "true";
    if (!input) return true;

    enforceMinDate(input, picker);
    syncDeliveryPropertyToForm(picker);

    if (required && !input.value) {
      picker.classList.add("is-invalid");
      if (error) error.hidden = false;
      if (trigger) trigger.focus();
      return false;
    }

    picker.classList.remove("is-invalid");
    if (error) error.hidden = true;
    return true;
  }

  function closeDropdown(picker) {
    var dropdown = picker.querySelector("[data-delivery-date-dropdown]");
    var trigger = picker.querySelector("[data-delivery-date-trigger]");
    if (dropdown) dropdown.hidden = true;
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    picker.classList.remove("is-open");
  }

  function closeAllDropdowns(except) {
    document.querySelectorAll("[data-delivery-date-picker]").forEach(function (picker) {
      if (except && picker === except) return;
      closeDropdown(picker);
    });
  }

  function renderCalendar(picker) {
    var daysEl = picker.querySelector("[data-cal-days]");
    var monthEl = picker.querySelector("[data-cal-month]");
    var input = picker.querySelector("[data-delivery-date-input]");
    if (!daysEl || !monthEl || !input) return;

    var viewYear = Number(picker._calYear);
    var viewMonth = Number(picker._calMonth);
    var minIso = getMinDateForPicker(picker);
    var selectedIso = input.value || "";
    var today = todayIso(picker);

    monthEl.textContent = MONTH_NAMES[viewMonth] + " " + viewYear;
    daysEl.innerHTML = "";

    var firstDay = new Date(viewYear, viewMonth, 1);
    // UK calendars start the week on Monday.
    var startWeekday = (firstDay.getDay() + 6) % 7;
    var daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

    for (var i = 0; i < startWeekday; i++) {
      var empty = document.createElement("span");
      empty.className = "delivery-date-picker__day is-empty";
      empty.setAttribute("aria-hidden", "true");
      daysEl.appendChild(empty);
    }

    for (var day = 1; day <= daysInMonth; day++) {
      var iso = viewYear + "-" + pad(viewMonth + 1) + "-" + pad(day);
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "delivery-date-picker__day";
      btn.textContent = String(day);
      btn.setAttribute("data-date", iso);

      if (iso < minIso) {
        btn.classList.add("is-disabled");
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");
      }

      if (iso === today) btn.classList.add("is-today");
      if (iso === selectedIso) {
        btn.classList.add("is-selected");
        btn.setAttribute("aria-current", "date");
      }

      daysEl.appendChild(btn);
    }
  }

  function openDropdown(picker) {
    var input = picker.querySelector("[data-delivery-date-input]");
    var dropdown = picker.querySelector("[data-delivery-date-dropdown]");
    var trigger = picker.querySelector("[data-delivery-date-trigger]");
    if (!input || !dropdown) return;

    enforceMinDate(input, picker);
    closeAllDropdowns(picker);

    var base = parseIso(input.value) || parseIso(getMinDateForPicker(picker)) || new Date();
    picker._calYear = base.getFullYear();
    picker._calMonth = base.getMonth();
    renderCalendar(picker);

    dropdown.hidden = false;
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    picker.classList.add("is-open");
  }

  function toggleDropdown(picker) {
    var dropdown = picker.querySelector("[data-delivery-date-dropdown]");
    if (!dropdown) return;
    if (dropdown.hidden) openDropdown(picker);
    else closeDropdown(picker);
  }

  function collectDeliveryDatesFromCart(cart) {
    var lines = [];
    var seen = {};
    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      Object.keys(props).forEach(function (key) {
        if (!key) return;
        if (key.toLowerCase().indexOf("delivery") === -1) return;
        var value = props[key];
        if (!value) return;
        var display = toPropertyDisplayValue(value);
        var line = key + ": " + display;
        var dedupeKey = key.toLowerCase() + "|" + String(display).toLowerCase();
        if (!seen[dedupeKey]) {
          seen[dedupeKey] = true;
          lines.push(line);
        }
      });
    });
    // Only one delivery line should ever go into the order note.
    return lines.slice(0, 1);
  }

  function isDeliveryNoteLine(line, propertyName) {
    var trimmed = String(line || "").trim();
    if (!trimmed) return false;
    var lower = trimmed.toLowerCase();

    // Always strip the currently configured Property name (any custom label).
    var names = [];
    if (propertyName) names.push(String(propertyName));
    var storedName = recallStoredPropertyName();
    if (storedName) names.push(storedName);
    names.push("Delivery Date", "Delivery After");

    for (var i = 0; i < names.length; i++) {
      var prefix = String(names[i] || "").trim().toLowerCase() + ":";
      if (prefix !== ":" && lower.indexOf(prefix) === 0) return true;
    }

    // Fallback for typical delivery-style labels.
    if (/^delivery(\s+\w+){0,3}\s*:/.test(lower)) return true;
    return false;
  }

  function stripDeliveryNotes(note, propertyName) {
    if (!note) return "";
    return String(note)
      .split("\n")
      .filter(function (line) {
        return !isDeliveryNoteLine(line, propertyName);
      })
      .join("\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
  }

  function buildUpdatedNote(existingNote, cart) {
    var resolved = resolveSelectedDate(cart);
    var cleaned = stripDeliveryNotes(existingNote, resolved.propertyName);
    var deliveryLines = collectDeliveryDatesFromCart(cart);
    if (!deliveryLines.length && resolved.value) {
      deliveryLines = [resolved.propertyName + ": " + toPropertyDisplayValue(resolved.value)];
    }
    if (!deliveryLines.length) return cleaned;
    // Never append more than one delivery selection line.
    var deliveryBlock = deliveryLines[0];
    return cleaned ? cleaned + "\n" + deliveryBlock : deliveryBlock;
  }

  function getDeliveryAttributePayload(cart) {
    var resolved = resolveSelectedDate(cart);
    var propertyName = resolved.propertyName || "Delivery Date";
    var display = resolved.value ? toPropertyDisplayValue(resolved.value) : "";

    if (!display) {
      var fromItems = collectDeliveryDatesFromCart(cart);
      if (fromItems.length) {
        var match = String(fromItems[0]).match(/^([^:]+):\s*(.+)$/);
        if (match) {
          propertyName = match[1].trim() || propertyName;
          display = match[2].trim();
        } else {
          display = fromItems[0].replace(/^[^:]+:\s*/i, "").trim();
        }
      }
    }

    // Prefer the property key already on a line item (matches Theme Editor "Property name").
    if (cart && cart.items) {
      cart.items.some(function (item) {
        var props = item.properties || {};
        return Object.keys(props).some(function (key) {
          if (!key || key.toLowerCase().indexOf("delivery") === -1 || !props[key]) return false;
          propertyName = key;
          if (!display) display = toPropertyDisplayValue(props[key]);
          return true;
        });
      });
    }

    if (!display) return null;

    var attrs = {};
    attrs[propertyName] = display;
    // Clear legacy / renamed keys so Additional details only shows the current Property name.
    attrs["Delivery Date"] = propertyName === "Delivery Date" ? display : "";
    attrs["Delivery After"] = propertyName === "Delivery After" ? display : "";
    attrs["ddp_tag"] = "";
    if (cart && cart.attributes) {
      Object.keys(cart.attributes).forEach(function (key) {
        if (!key || key === propertyName || key === "ddp_tag") return;
        if (key.toLowerCase().indexOf("delivery") === -1) return;
        attrs[key] = "";
      });
    }
    var storedName = recallStoredPropertyName();
    if (storedName && storedName !== propertyName) attrs[storedName] = "";
    return attrs;
  }

  var noteUpdateTimer = null;

  function notesEqual(a, b) {
    return String(a || "").replace(/\r\n/g, "\n").trim() === String(b || "").replace(/\r\n/g, "\n").trim();
  }

  function updateCartNoteFromCart(cart) {
    if (!cart) return;

    // Debounce + re-fetch so rapid cart:change / GPO retries never append duplicate lines.
    clearTimeout(noteUpdateTimer);
    noteUpdateTimer = setTimeout(function () {
      if (syncingNote) return;
      syncingNote = true;

      fetch(getCartRoot() + "cart.js", { credentials: "same-origin" })
        .then(function (res) {
          return res.json();
        })
        .then(function (freshCart) {
          var nextNote = buildUpdatedNote(freshCart.note || "", freshCart);
          var attrs = getDeliveryAttributePayload(freshCart);
          var currentAttrs = freshCart.attributes || {};
          var attrsChanged = false;

          if (attrs) {
            Object.keys(attrs).forEach(function (key) {
              if (String(currentAttrs[key] || "") !== String(attrs[key])) attrsChanged = true;
            });
          }

          if (notesEqual(freshCart.note, nextNote) && !attrsChanged) return null;

          var body = { note: nextNote };
          if (attrs) body.attributes = attrs;

          return fetch(getCartRoot() + "cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            credentials: "same-origin",
            body: JSON.stringify(body)
          });
        })
        .catch(function () {})
        .finally(function () {
          syncingNote = false;
        });
    }, 400);
  }

  function bindDeliveryDatePickers() {
    var pickers = document.querySelectorAll("[data-delivery-date-picker]");

    pickers.forEach(function (picker) {
      var input = picker.querySelector("[data-delivery-date-input]");
      var trigger = picker.querySelector("[data-delivery-date-trigger]");
      var dropdown = picker.querySelector("[data-delivery-date-dropdown]");
      var prev = picker.querySelector("[data-cal-prev]");
      var next = picker.querySelector("[data-cal-next]");
      if (!input || !trigger || !dropdown || !prev || !next) return;

      enforceMinDate(input, picker);
      updateDisplay(picker);
      syncDeliveryPropertyToForm(picker);

      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleDropdown(picker);
      });

      prev.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        picker._calMonth -= 1;
        if (picker._calMonth < 0) {
          picker._calMonth = 11;
          picker._calYear -= 1;
        }
        renderCalendar(picker);
      });

      next.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        picker._calMonth += 1;
        if (picker._calMonth > 11) {
          picker._calMonth = 0;
          picker._calYear += 1;
        }
        renderCalendar(picker);
      });

      dropdown.addEventListener("click", function (event) {
        var dayBtn = event.target.closest("[data-date]");
        if (!dayBtn || dayBtn.disabled || dayBtn.classList.contains("is-disabled")) return;
        event.preventDefault();
        event.stopPropagation();
        input.value = dayBtn.getAttribute("data-date");
        input.disabled = false;
        input.dispatchEvent(new Event("change", { bubbles: true }));
        updateDisplay(picker);
        syncDeliveryPropertyToForm(picker);
        closeDropdown(picker);
        // Persist to cart attributes immediately so order Additional details + Flow tags work.
        fetch(getCartRoot() + "cart.js")
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateCartNoteFromCart(cart);
          })
          .catch(function () {});
      });
    });

    // Before any product form submit / GPO add, force-sync the property into the form.
    document.addEventListener(
      "submit",
      function () {
        document.querySelectorAll("[data-delivery-date-picker]").forEach(syncDeliveryPropertyToForm);
      },
      true
    );

    document.addEventListener("click", function (event) {
      var buyButtons = event.target && event.target.closest("buy-buttons, [name='add'], .product-form__submit, button[type='submit']");
      if (!buyButtons) return;
      document.querySelectorAll("[data-delivery-date-picker]").forEach(syncDeliveryPropertyToForm);
    }, true);

    patchCartNetwork();

    // Before checkout, force delivery property onto the main line item so it reaches the order admin.
    document.addEventListener(
      "click",
      function (event) {
        var checkoutEl = event.target && event.target.closest('[name="checkout"], form[action*="/checkout"] button, a[href*="/checkout"]');
        if (!checkoutEl || checkoutEl.getAttribute("data-ddp-checkout-ready") === "1") return;

        document.querySelectorAll("[data-delivery-date-picker]").forEach(syncDeliveryPropertyToForm);
        var quick = getActiveDeliverySelection();
        var maybeHasDate =
          !!quick.displayValue ||
          !!recallDeliveryDate("__last") ||
          !!recallStoredPropertyName() ||
          !!document.querySelector("[data-delivery-date-picker]");
        if (!maybeHasDate) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();

        function proceedCheckout() {
          checkoutEl.setAttribute("data-ddp-checkout-ready", "1");
          if (checkoutEl.tagName === "A" && checkoutEl.href) {
            window.location.href = checkoutEl.href;
            return;
          }
          checkoutEl.click();
        }

        fetch(getCartRoot() + "cart.js", { credentials: "same-origin" })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var resolved = resolveSelectedDate(cart);
            if (!resolved.value) return null;

            return ensureDeliveryPropertyWithRetry(cart).then(function (next) {
              updateCartNoteFromCart(next || cart);
              return next || cart;
            });
          })
          .catch(function () { return null; })
          .then(function () {
            proceedCheckout();
          });
      },
      true
    );

    // Repair on cart / drawer pages even without the product picker.
    fetch(getCartRoot() + "cart.js", { credentials: "same-origin" })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        return ensureDeliveryPropertyWithRetry(cart).then(function (next) {
          updateCartNoteFromCart(next || cart);
        });
      })
      .catch(function () {});

    document.addEventListener("click", function (event) {
      if (event.target.closest("[data-delivery-date-picker]")) {
        var host = event.target.closest("[data-delivery-date-picker]");
        document.querySelectorAll("[data-delivery-date-picker]").forEach(function (picker) {
          if (picker !== host) closeDropdown(picker);
        });
        return;
      }
      closeAllDropdowns();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeAllDropdowns();
    });

    document.addEventListener(
      "submit",
      function (event) {
        var form = event.target;
        if (!form || form.tagName !== "FORM") return;

        var relatedPickers = [];
        pickers.forEach(function (picker) {
          var input = picker.querySelector("[data-delivery-date-input]");
          if (!input) return;
          var formId = input.getAttribute("form");
          if ((formId && form.id === formId) || form.contains(input)) {
            relatedPickers.push(picker);
          }
        });

        if (!relatedPickers.length) return;

        var valid = true;
        relatedPickers.forEach(function (picker) {
          if (!validatePicker(picker)) valid = false;
        });

        if (!valid) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    document.addEventListener("click", function (event) {
      var buyButtons = event.target && event.target.closest("buy-buttons");
      if (!buyButtons) return;
      var formId = buyButtons.getAttribute("form");
      if (!formId) return;

      pickers.forEach(function (picker) {
        var input = picker.querySelector("[data-delivery-date-input]");
        if (!input || input.getAttribute("form") !== formId) return;
        if (picker.getAttribute("data-required") === "true" && !input.value) {
          validatePicker(picker);
        }
      });
    });

    function repairDeliveryProperty(cart, addedItems) {
      return ensureDeliveryPropertyWithRetry(cart).then(function (nextCart) {
        var resolved = resolveSelectedDate(nextCart || cart);
        if (!resolved.value || !nextCart || !nextCart.items) return nextCart;

        if (!cartHasDeliveryProperty(nextCart, resolved.propertyName)) {
          var main = findMainProductLine(nextCart, resolved.propertyName);
          if (main) return ensureDeliveryPropertyOnItems(nextCart, [main]);
        }
        return nextCart;
      });
    }

    function onCartEvent(event) {
      var cart = event && event.detail && event.detail.cart;

      function finish(nextCart) {
        if (nextCart) updateCartNoteFromCart(nextCart);
      }

      function runRepair(sourceCart) {
        repairDeliveryProperty(sourceCart, null)
          .then(finish)
          .catch(function () {
            finish(sourceCart);
          });

        // GPO often updates the cart again after add and can drop custom properties.
        [700, 1600, 2800, 4200].forEach(function (delay) {
          setTimeout(function () {
            fetch(getCartRoot() + "cart.js", { credentials: "same-origin" })
              .then(function (res) { return res.json(); })
              .then(function (liveCart) {
                return repairDeliveryProperty(liveCart, null).then(finish);
              })
              .catch(function () {});
          }, delay);
        });
      }

      if (cart) {
        runRepair(cart);
        return;
      }

      fetch(getCartRoot() + "cart.js", { credentials: "same-origin" })
        .then(function (res) { return res.json(); })
        .then(runRepair)
        .catch(function () {});
    }

    document.addEventListener("cart:change", onCartEvent);
    document.documentElement.addEventListener("cart:change", onCartEvent);
    document.addEventListener("variant:add", onCartEvent);
    document.documentElement.addEventListener("variant:add", onCartEvent);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindDeliveryDatePickers);
  } else {
    bindDeliveryDatePickers();
  }
})();

/* -------------------------------------------------------------------------- */
/* Add-on product block — checkbox bundles item with main ATC                 */
/* -------------------------------------------------------------------------- */
(function () {
  if (window.__addonProductBootstrapped) return;
  window.__addonProductBootstrapped = true;

  var boundForms = new WeakSet();
  var mainPriceByForm = {};

  function getFormById(formId) {
    if (!formId) return null;
    return document.getElementById(formId) || document.forms[formId] || null;
  }

  function getMoneyFormat() {
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    if (settings.currencyCodeEnabled) {
      return settings.moneyWithCurrencyFormat || settings.moneyFormat || "{{amount}}";
    }
    return settings.moneyFormat || "{{amount}}";
  }

  function formatMoneyCents(cents) {
    cents = Math.max(0, Number(cents) || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return String(window.Shopify.formatMoney(cents, getMoneyFormat()))
        .replace(/Â£/g, "\u00A3")
        .replace(/&pound;/gi, "\u00A3")
        .replace(/&#163;/g, "\u00A3");
    }
    return "\u00A3" + (cents / 100).toFixed(2);
  }

  function parseMoneyToCents(text) {
    if (!text) return null;
    var cleaned = String(text).replace(/[^\d.,]/g, "").trim();
    if (!cleaned) return null;

    var hasComma = cleaned.indexOf(",") > -1;
    var hasDot = cleaned.indexOf(".") > -1;

    if (hasComma && hasDot) {
      if (cleaned.lastIndexOf(",") > cleaned.lastIndexOf(".")) {
        cleaned = cleaned.replace(/\./g, "").replace(",", ".");
      } else {
        cleaned = cleaned.replace(/,/g, "");
      }
    } else if (hasComma) {
      cleaned = cleaned.replace(",", ".");
    }

    var value = parseFloat(cleaned);
    if (isNaN(value)) return null;
    return Math.round(value * 100);
  }

  function ensureMainPriceState(formId) {
    if (!mainPriceByForm[formId]) {
      mainPriceByForm[formId] = { price: null, compareAt: null };
    }
    return mainPriceByForm[formId];
  }

  function captureMainPriceFromDom(formId) {
    var state = ensureMainPriceState(formId);
    var salePrice = document.querySelector('sale-price[form="' + formId + '"]');
    var compareAt = document.querySelector('compare-at-price[form="' + formId + '"]');

    if (salePrice) {
      var priceCents = parseMoneyToCents(salePrice.textContent);
      if (priceCents != null) state.price = priceCents;
    }

    if (compareAt && !compareAt.hidden) {
      var compareCents = parseMoneyToCents(compareAt.textContent);
      if (compareCents != null) state.compareAt = compareCents;
    } else if (state.price != null) {
      state.compareAt = null;
    }

    return state;
  }

  function collectAllCheckedAddons() {
    return Array.prototype.slice.call(document.querySelectorAll("addon-product")).filter(function (el) {
      return typeof el.isChecked === "function" && el.isChecked() && el.getVariantId();
    });
  }

  function collectCheckedAddons(formId) {
    if (!formId) return collectAllCheckedAddons();
    return collectAllCheckedAddons().filter(function (el) {
      return el.getAttribute("form") === formId;
    });
  }

  function getCheckedAddonTotals(formId) {
    var price = 0;
    var compareAt = 0;

    collectCheckedAddons(formId).forEach(function (addon) {
      price += addon.getPriceCents() || 0;
      compareAt += addon.getCompareAtCents() || addon.getPriceCents() || 0;
    });

    return { price: price, compareAt: compareAt };
  }

  function setPriceNodeText(node, moneyText) {
    if (!node) return;
    var srOnly = node.querySelector(".sr-only");
    node.innerHTML = (srOnly ? srOnly.outerHTML : "") + moneyText;
  }

  function updateMainProductPrice(formId) {
    if (!formId) return;

    var state = ensureMainPriceState(formId);
    if (state.price == null) captureMainPriceFromDom(formId);
    if (state.price == null) return;

    var addons = getCheckedAddonTotals(formId);
    var totalPrice = state.price + addons.price;
    var baseCompare = state.compareAt != null && state.compareAt > state.price ? state.compareAt : state.price;
    var totalCompare = baseCompare + addons.compareAt;
    var showCompare = totalCompare > totalPrice;

    document.querySelectorAll('sale-price[form="' + formId + '"]').forEach(function (node) {
      setPriceNodeText(node, formatMoneyCents(totalPrice));
      node.classList.toggle("text-on-sale", showCompare);
    });

    document.querySelectorAll('compare-at-price[form="' + formId + '"]').forEach(function (node) {
      if (showCompare) {
        setPriceNodeText(node, formatMoneyCents(totalCompare));
        node.hidden = false;
        node.removeAttribute("hidden");
      } else {
        node.hidden = true;
        node.setAttribute("hidden", "");
      }
    });
  }

  function extractPropertiesFromFormData(formData) {
    var properties = {};
    var hasProps = false;
    formData.forEach(function (value, key) {
      if (key.indexOf("properties[") !== 0) return;
      hasProps = true;
      properties[key.replace(/^properties\[/, "").replace(/\]$/, "")] = value;
    });
    return hasProps ? properties : null;
  }

  function buildItemsPayloadFromFormData(formData, addonElements) {
    var mainId = formData.get("id");
    if (!mainId) return null;

    var item = {
      id: Number(mainId),
      quantity: parseInt(formData.get("quantity") || "1", 10) || 1
    };

    var properties = extractPropertiesFromFormData(formData);
    if (properties) item.properties = properties;

    var sellingPlan = formData.get("selling_plan");
    if (sellingPlan) item.selling_plan = sellingPlan;

    var items = [item];
    addonElements.forEach(function (addon) {
      items.push({ id: Number(addon.getVariantId()), quantity: 1 });
    });

    var payload = { items: items };
    var sections = formData.get("sections");
    var sectionsUrl = formData.get("sections_url");
    if (sections) payload.sections = sections;
    if (sectionsUrl) payload.sections_url = sectionsUrl;
    return payload;
  }

  function mergeAddonsIntoJsonBody(rawBody, addonElements) {
    try {
      var json = typeof rawBody === "string" ? JSON.parse(rawBody) : rawBody;
      if (!json || typeof json !== "object") return null;

      var existingIds = {};
      var items = Array.isArray(json.items) ? json.items.slice() : null;

      if (!items) {
        if (!json.id) return null;
        items = [
          {
            id: Number(json.id),
            quantity: parseInt(json.quantity || 1, 10) || 1,
            properties: json.properties || undefined,
            selling_plan: json.selling_plan || undefined
          }
        ];
      }

      items.forEach(function (item) {
        if (item && item.id != null) existingIds[String(item.id)] = true;
      });

      addonElements.forEach(function (addon) {
        var id = String(addon.getVariantId());
        if (existingIds[id]) return;
        items.push({ id: Number(id), quantity: 1 });
        existingIds[id] = true;
      });

      json.items = items;
      delete json.id;
      delete json.quantity;
      return json;
    } catch (e) {
      return null;
    }
  }

  function patchAddonCartFetch() {
    if (window.__addonCartFetchPatched) return;
    window.__addonCartFetchPatched = true;

    var originalFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : input && input.url ? input.url : "";
      if (!/\/cart\/add(\.js)?(\?|$)/.test(String(url))) {
        return originalFetch(input, init);
      }

      var addons = collectAllCheckedAddons();
      if (!addons.length) {
        return originalFetch(input, init);
      }

      init = init ? Object.assign({}, init) : {};
      var body = init.body;

      if (typeof FormData !== "undefined" && body instanceof FormData) {
        var payload = buildItemsPayloadFromFormData(body, addons);
        if (!payload) return originalFetch(input, init);

        var headers = new Headers(init.headers || {});
        headers.set("Content-Type", "application/json");
        headers.set("Accept", "application/json");
        if (!headers.has("X-Requested-With")) headers.set("X-Requested-With", "XMLHttpRequest");

        return originalFetch(url, Object.assign({}, init, { headers: headers, body: JSON.stringify(payload) }));
      }

      if (typeof body === "string") {
        var merged = mergeAddonsIntoJsonBody(body, addons);
        if (!merged) return originalFetch(input, init);

        var jsonHeaders = new Headers(init.headers || {});
        jsonHeaders.set("Content-Type", "application/json");
        jsonHeaders.set("Accept", "application/json");
        if (!jsonHeaders.has("X-Requested-With")) jsonHeaders.set("X-Requested-With", "XMLHttpRequest");

        return originalFetch(url, Object.assign({}, init, { headers: jsonHeaders, body: JSON.stringify(merged) }));
      }

      return originalFetch(input, init);
    };
  }

  async function addItemsWithAddons(form, addonElements) {
    var submitButtons = Array.from(form.elements).filter(function (button) {
      return button.type === "submit";
    });
    submitButtons.forEach(function (submitButton) {
      submitButton.setAttribute("disabled", "disabled");
      submitButton.setAttribute("aria-busy", "true");
    });

    var sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    var formData = new FormData(form);
    formData.set("sections", sectionsToBundle.join(","));
    formData.set(
      "sections_url",
      ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "variants/" + formData.get("id")
    );

    var payload = buildItemsPayloadFromFormData(formData, addonElements);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

    try {
      var response = await fetch(root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify(payload)
      });

      var responseJson = await response.json();

      submitButtons.forEach(function (submitButton) {
        submitButton.removeAttribute("disabled");
        submitButton.removeAttribute("aria-busy");
      });

      if (response.ok) {
        if (
          window.themeVariables &&
          window.themeVariables.settings &&
          (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart")
        ) {
          window.location.href = root + "cart";
          return;
        }

        var cartContent = await (await fetch(root + "cart.js")).json();
        cartContent.sections = responseJson.sections;

        form.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              items: responseJson.items ? responseJson.items : [responseJson],
              cart: cartContent
            }
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartContent
            }
          })
        );
      } else {
        form.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson.description || responseJson.message || "Unable to add to cart"
            }
          })
        );
      }
    } catch (error) {
      submitButtons.forEach(function (submitButton) {
        submitButton.removeAttribute("disabled");
        submitButton.removeAttribute("aria-busy");
      });
      form.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: true,
          detail: { error: error && error.message ? error.message : "Unable to add to cart" }
        })
      );
    }
  }

  function bindForm(form) {
    if (!form || boundForms.has(form)) return;
    boundForms.add(form);

    captureMainPriceFromDom(form.id);

    form.addEventListener("variant:change", function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      var state = ensureMainPriceState(form.id);
      state.price = typeof variant.price === "number" ? variant.price : state.price;
      state.compareAt =
        typeof variant.compare_at_price === "number" && variant.compare_at_price > variant.price
          ? variant.compare_at_price
          : null;

      requestAnimationFrame(function () {
        updateMainProductPrice(form.id);
      });
      setTimeout(function () {
        updateMainProductPrice(form.id);
      }, 50);
    });

    form.addEventListener(
      "submit",
      function (event) {
        var addons = collectCheckedAddons(form.id);
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        addItemsWithAddons(form, addons);
      },
      true
    );
  }

  // Global fallback so we catch ATC even if form binding missed timing.
  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== "FORM" || form.getAttribute("is") !== "product-form") return;
      var addons = collectCheckedAddons(form.id);
      if (!addons.length) return;
      if (event.defaultPrevented) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      bindForm(form);
      addItemsWithAddons(form, addons);
    },
    true
  );

  class AddonProduct extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector("[data-addon-checkbox]");
      this.variantInput = this.querySelector("[data-addon-variant-id]");
      this.priceEl = this.querySelector("[data-addon-price]");
      this.compareAtEl = this.querySelector("[data-addon-compare-at]");
      this.mediaEl = this.querySelector("[data-addon-media]");
      this.imageEl = this.querySelector("[data-addon-image], .addon-product__image");
      this.optionSelects = Array.prototype.slice.call(this.querySelectorAll("[data-addon-option]"));
      this.productImage = this.getAttribute("data-product-image") || "";
      this.currentPriceCents = 0;
      this.currentCompareAtCents = 0;

      var jsonEl = this.querySelector("[data-addon-variants]");
      this.variants = [];
      try {
        this.variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      } catch (e) {
        this.variants = [];
      }

      this.optionSelects.forEach(
        function (select) {
          select.addEventListener("change", this.onAddonChange.bind(this));
          select.addEventListener("click", function (event) {
            event.stopPropagation();
          });
        }.bind(this)
      );

      if (this.checkbox) {
        this.checkbox.addEventListener("change", this.onAddonChange.bind(this));
      }

      this.updateVariant();

      var form = getFormById(this.getAttribute("form"));
      bindForm(form);
      updateMainProductPrice(this.getAttribute("form"));
    }

    onAddonChange() {
      this.updateVariant();
      updateMainProductPrice(this.getAttribute("form"));
    }

    isChecked() {
      return !!(this.checkbox && this.checkbox.checked && !this.checkbox.disabled);
    }

    getVariantId() {
      return this.variantInput ? String(this.variantInput.value || "") : "";
    }

    getPriceCents() {
      return this.currentPriceCents || 0;
    }

    getCompareAtCents() {
      return this.currentCompareAtCents || 0;
    }

    getSelectedOptions() {
      return this.optionSelects.map(function (select) {
        return String(select.value || "").trim();
      });
    }

    findVariant() {
      var selected = this.getSelectedOptions();
      if (!this.variants.length) return null;
      if (!selected.length) return this.variants[0] || null;

      return (
        this.variants.find(function (variant) {
          var options = (variant.options || []).map(function (option) {
            return String(option || "").trim();
          });
          if (options.length !== selected.length) return false;
          return options.every(function (option, index) {
            return option === selected[index];
          });
        }) || null
      );
    }

    ensureImageEl() {
      if (this.imageEl) return this.imageEl;
      if (!this.mediaEl) return null;
      this.imageEl = document.createElement("img");
      this.imageEl.className = "addon-product__image";
      this.imageEl.setAttribute("data-addon-image", "");
      this.imageEl.loading = "lazy";
      this.imageEl.alt = "";
      this.imageEl.width = 64;
      this.imageEl.height = 64;
      this.mediaEl.appendChild(this.imageEl);
      return this.imageEl;
    }

    updateImage(variant) {
      var imageUrl = (variant && variant.image) || this.productImage || "";
      if (!imageUrl) return;
      var img = this.ensureImageEl();
      if (!img) return;
      img.removeAttribute("srcset");
      img.removeAttribute("sizes");
      img.src = imageUrl;
    }

    updateVariant() {
      var variant = this.findVariant();
      if (!variant) {
        this.classList.add("is-unavailable");
        if (this.checkbox) this.checkbox.disabled = true;
        this.currentPriceCents = 0;
        this.currentCompareAtCents = 0;
        return;
      }

      if (this.variantInput) this.variantInput.value = variant.id;
      this.currentPriceCents = Number(variant.price) || 0;
      this.currentCompareAtCents =
        variant.compare_at_price && variant.compare_at_price > variant.price
          ? Number(variant.compare_at_price)
          : 0;

      if (this.priceEl) this.priceEl.textContent = variant.price_formatted;

      if (this.compareAtEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price && variant.compare_at_price_formatted) {
          this.compareAtEl.textContent = variant.compare_at_price_formatted;
          this.compareAtEl.hidden = false;
          this.compareAtEl.removeAttribute("hidden");
        } else {
          this.compareAtEl.hidden = true;
          this.compareAtEl.setAttribute("hidden", "");
        }
      }

      this.updateImage(variant);

      this.classList.toggle("is-unavailable", !variant.available);
      if (this.checkbox) {
        this.checkbox.disabled = !variant.available;
        if (!variant.available) this.checkbox.checked = false;
      }
    }
  }

  patchAddonCartFetch();

  if (!window.customElements.get("addon-product")) {
    window.customElements.define("addon-product", AddonProduct);
  } else {
    // Element already defined (hot reload) — still ensure existing nodes bind forms.
    document.querySelectorAll("addon-product").forEach(function (el) {
      var form = getFormById(el.getAttribute("form"));
      bindForm(form);
    });
  }
})();

/* Mystery gift (cart drawer footer)
 * The selection is remembered in localStorage. The gift is only added to the cart when the customer
 * goes to checkout, and removed again when they come back to the store, so it never shows as a cart item.
 */
(function () {
  var STORAGE_KEY = "mysteryGiftSelected";
  var GIFT_PROPERTY = "_mystery_gift";

  function isSelected() {
    try {
      return localStorage.getItem(STORAGE_KEY) === "true";
    } catch (error) {
      return false;
    }
  }

  function setSelected(selected) {
    try {
      selected ? localStorage.setItem(STORAGE_KEY, "true") : localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function isGiftLine(lineItem) {
    return lineItem.properties && lineItem.properties[GIFT_PROPERTY];
  }

  function fetchCartJson() {
    return fetch(Shopify.routes.root + "cart.js").then(function (response) {
      return response.json();
    });
  }

  class MysteryGift extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector(".mystery-gift__checkbox");
      this.checkbox.checked = isSelected();
      this.checkbox.addEventListener("change", function () {
        setSelected(this.checked);
        document.querySelectorAll(".mystery-gift__checkbox").forEach((checkbox) => checkbox.checked = this.checked);
      });
    }
  }

  if (!window.customElements.get("mystery-gift")) {
    window.customElements.define("mystery-gift", MysteryGift);
  }

  // Add the gift right before going to checkout
  document.addEventListener("submit", function (event) {
    var submitter = event.submitter;
    var giftElement = document.querySelector("mystery-gift[data-variant-id]");

    if (!submitter || submitter.name !== "checkout" || !giftElement || !isSelected()) {
      return;
    }

    event.preventDefault();
    submitter.setAttribute("aria-busy", "true");

    fetchCartJson()
      .then(function (cart) {
        if (cart.items.some(isGiftLine)) {
          return;
        }

        var properties = {};
        properties[GIFT_PROPERTY] = "true";

        return fetch(Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: parseInt(giftElement.dataset.variantId), quantity: 1, properties: properties }] })
        });
      })
      .catch(function () {})
      .finally(function () {
        window.location.href = Shopify.routes.root + "checkout";
      });
  }, true);

  // Remove the gift when the customer comes back from checkout (the selection itself is kept)
  function removeGiftFromCart() {
    fetchCartJson().then(function (cart) {
      var updates = {};

      cart.items.forEach(function (lineItem) {
        if (isGiftLine(lineItem)) {
          updates[lineItem.key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) {
        return;
      }

      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

      return fetch(Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates, sections: sectionsToBundle })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cartContent) {
          document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "mystery-gift:remove", cart: cartContent } }));
        });
    });
  }

  removeGiftFromCart();

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      removeGiftFromCart();
    }
  });
})();
